export const projectStatusCodeMap = {
    'CLOSED': 'C',
    'ACTIVE': 'A',
    'RELEASE': 'R',
    'DEVELOPMENT': 'D',
    'UPCOMING': 'U',
    'CHECKLIST_NA': 'N',
    
}

export const routesActiveTabMap = ['closed', 'active', 'upcoming', 'development', 'release', 'checklist_na', 'datatracker_pending', 'datatracker_progress', 'datatracker_na', 'datatracker_complete', 'datatracker_matched-duplicate','datatracker_all','datatracker_hold','fmptracker_all','fmptracker_pending','fmptracker_progress','fmptracker_review','fmptracker_asbuilts','fmptracker_complete'];